import { FormControl } from '@angular/forms';
import {
    Component,
    ViewEncapsulation,
    Input,
    HostListener,
    AfterViewInit,
    ContentChild,
    ViewChild,
    ElementRef,
    Renderer2
} from '@angular/core';
import { UploadFileDirective } from '../upload-file.directive';
export class UploadContainerComponent implements AfterViewInit {

     placeholder = 'Upload file';
     hint = '';
     uploadFile: UploadFileDirective;
     uploadInput: ElementRef;
    filename: string;
/**
 * @param {?} render
 */
constructor(
private render: Renderer2
    ) {
    }
/**
 * @param {?} e
 * @return {?}
 */
onClick(e) {
        this.uploadInput.nativeElement.click();
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.render.listen(this.uploadInput.nativeElement, 'change', e => {
            if (e.target.files.length) {
                this.filename = e.target.files[0].name;
            }
            const /** @type {?} */ fileList: FileList = e.target.files;
            if (fileList.length > 0) {
                const /** @type {?} */ file: File = fileList[0];
                const /** @type {?} */ myReader: FileReader = new FileReader();
                myReader.onloadend = (event) => {
                    const /** @type {?} */ image = myReader.result;
                    this.uploadFile.setValue(image);
                }
                myReader.readAsDataURL(file);
            }
        });
    }
/**
 * @param {?} evt
 * @return {?}
 */
public onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        // this.background = '#999';
    }
/**
 * @param {?} evt
 * @return {?}
 */
public onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        // this.background = '#eee'
    }
/**
 * @param {?} evt
 * @return {?}
 */
public onDrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.dataTransfer.files.length) {
            this.filename = evt.dataTransfer.files[0].name;
        }
        const /** @type {?} */ fileList: FileList = evt.dataTransfer.files;
        if (fileList.length > 0) {
            const /** @type {?} */ file: File = fileList[0];
            const /** @type {?} */ myReader: FileReader = new FileReader();
            myReader.onloadend = (event) => {
                const /** @type {?} */ image = myReader.result;
                this.uploadFile.setValue(image);
            }
            myReader.readAsDataURL(file);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'hd-upload-container',
  template: `
    <ng-content></ng-content>
    <div class='hd-upload-container'>
        <input type='file' #filetoupload style='display:none;'>
        <mat-icon>file_upload</mat-icon>
        <span class='hd-upload-placeholder'>{{placeholder}}</span>
        <span class='hd-upload-filename'>{{filename}}</span>
        <span class='hd-upload-hint'>{{hint}}</span>
    </div>
  `,
  styles: [`
    .hd-upload-container {
      margin: 15px 0;
      cursor: pointer;
      border: thin dashed #676c7b;
      color: #676c7b;
      padding: 20px;
      text-align: center; }
      .hd-upload-container .mat-icon {
        vertical-align: middle; }
      .hd-upload-container .hd-upload-hint {
        text-align: center;
        display: block;
        font-size: 10px; }
      .hd-upload-container .hd-upload-filename {
        display: block;
        text-align: center;
        font-size: 12px;
        min-height: 18px; }

    input[type=file] {
      display: none; }
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'placeholder': [{ type: Input },],
'hint': [{ type: Input },],
'uploadFile': [{ type: ContentChild, args: [UploadFileDirective, ] },],
'uploadInput': [{ type: ViewChild, args: ['filetoupload', ] },],
'onClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
'onDragOver': [{ type: HostListener, args: ['dragover', ['$event'], ] },],
'onDragLeave': [{ type: HostListener, args: ['dragleave', ['$event'], ] },],
'onDrop': [{ type: HostListener, args: ['drop', ['$event'], ] },],
};
}

function UploadContainerComponent_tsickle_Closure_declarations() {
/** @type {?} */
UploadContainerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UploadContainerComponent.ctorParameters;
/** @type {?} */
UploadContainerComponent.propDecorators;
/** @type {?} */
UploadContainerComponent.prototype.placeholder;
/** @type {?} */
UploadContainerComponent.prototype.hint;
/** @type {?} */
UploadContainerComponent.prototype.uploadFile;
/** @type {?} */
UploadContainerComponent.prototype.uploadInput;
/** @type {?} */
UploadContainerComponent.prototype.filename;
/** @type {?} */
UploadContainerComponent.prototype.render;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
